export enum UploadType {
  file = 'File',
  folderFile = 'FolderFile',
  deviceBackupFile = 'DeviceBackupFile',
  cctvFile = 'CctvFile',
  deviceBackup = 'DeviceBackup',
  cctv = 'Cctv',
  zipGeneralContent = 'ZipGeneralContent',
  zipCctv = 'ZipCctv',
  zipDeviceBackup = 'ZipDeviceBackup',
  generalContentFile = 'GeneralContentFile',
  generalContent = 'GeneralContent'
}

export const folderFileUploadTypes = [
  UploadType.deviceBackupFile,
  UploadType.cctvFile,
  UploadType.generalContentFile
];

export const zipUploadTypes = [
  UploadType.zipCctv,
  UploadType.zipDeviceBackup,
  UploadType.zipGeneralContent
];

export const archivedFolderUploadTypes = [
  UploadType.deviceBackup,
  UploadType.generalContent,
  UploadType.cctv
];

export const uploadArchiveTypes = [
  ...folderFileUploadTypes,
  ...zipUploadTypes,
  ...archivedFolderUploadTypes
];